import { StudioState } from '../../types/store';
import { setBreadcrumbs } from '../../actions/studio/page';

export const handleFetchBreadcrumbs = (state: StudioState): StudioState => ({
  ...state,
  breadcrumbs: {
    results: undefined,
    status: 'busy',
  },
});

export const handleSetBreadcrumbs = (
  state: StudioState,
  action: ReturnType<typeof setBreadcrumbs>
): StudioState => ({
  ...state,
  breadcrumbs: {
    results: action.payload.breadcrumbs,
    status: 'idle',
  },
});
